import { UserRole } from '@textile-pos/types';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useAuth } from '@/context/AuthContext';
import { Login } from '@/features/auth/pages/Login';
import { SaaSLogin } from '@/features/auth/pages/SaaSLogin';
// Feature pages (lazy-loadable in future)
import { BillingDashboard } from '@/features/billing/pages/BillingDashboard';
import { InventoryDashboard } from '@/features/inventory/pages/InventoryDashboard';
import { ReturnsDashboard } from '@/features/returns/pages/ReturnsDashboard';
import { SaasAdminDashboard } from '@/features/saas-admin/pages/SuperAdminDashboard';
import { PlatformTelemetry } from '@/features/saas-admin/pages/PlatformTelemetry';
import { AuditTrail } from '@/features/saas-admin/pages/AuditTrail';
import { SubscriptionPlans } from '@/features/saas-admin/pages/SubscriptionPlans';
import { ReportsDashboard } from '@/features/reports/pages/ReportsDashboard';
import { CompanySettings } from '@/features/tenant-admin/pages/CompanySettings';
import { CustomerDirectory } from '@/features/customers/pages/CustomerDirectory';
import { TenantDashboard } from '@/features/dashboard/pages/TenantDashboard';
import { Profile } from '@/features/profile/pages/Profile';
import { DashboardLayout } from '@/layouts/DashboardLayout';

export function HomeRedirect() {
  const { user } = useAuth();
  if (user?.role === UserRole.SUPER_ADMIN) {
    return <Navigate to="/saas-admin" replace />;
  }
  return <Navigate to="/inventory" replace />;
}

export function AppRoutes() {
  const { isAuthenticated, user } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            user?.role === UserRole.SUPER_ADMIN ? (
              <Navigate to="/saas-admin" replace />
            ) : (
              <Navigate to="/" replace />
            )
          ) : (
            <Login />
          )
        }
      />
      <Route
        path="/saas-login"
        element={
          isAuthenticated ? (
            user?.role === UserRole.SUPER_ADMIN ? (
              <Navigate to="/saas-admin" replace />
            ) : (
              <Navigate to="/" replace />
            )
          ) : (
            <SaaSLogin />
          )
        }
      />

      <Route element={isAuthenticated ? <DashboardLayout /> : <Navigate to="/login" replace />}>
        <Route
          path="/"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <Navigate to="/saas-admin" replace />
            ) : (
              <TenantDashboard />
            )
          }
        />

        <Route
          path="/inventory"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <Navigate to="/saas-admin" replace />
            ) : (
              <InventoryDashboard />
            )
          }
        />
        <Route
          path="/billing"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <Navigate to="/saas-admin" replace />
            ) : (
              <BillingDashboard />
            )
          }
        />
        <Route
          path="/customers"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <Navigate to="/saas-admin" replace />
            ) : (
              <CustomerDirectory />
            )
          }
        />
        <Route
          path="/returns"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <Navigate to="/saas-admin" replace />
            ) : (
              <ReturnsDashboard />
            )
          }
        />
        <Route
          path="/reports"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <Navigate to="/saas-admin" replace />
            ) : (
              <ReportsDashboard />
            )
          }
        />
        <Route
          path="/settings"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <Navigate to="/saas-admin" replace />
            ) : (
              <CompanySettings />
            )
          }
        />
        <Route
          path="/profile"
          element={<Profile />}
        />
        <Route
          path="/saas-admin"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <SaasAdminDashboard />
            ) : (
              <Navigate to="/inventory" replace />
            )
          }
        />
        <Route
          path="/saas-admin/plans"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <SubscriptionPlans />
            ) : (
              <Navigate to="/inventory" replace />
            )
          }
        />
        <Route
          path="/saas-admin/telemetry"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <PlatformTelemetry />
            ) : (
              <Navigate to="/inventory" replace />
            )
          }
        />
        <Route
          path="/saas-admin/audits"
          element={
            user?.role === UserRole.SUPER_ADMIN ? (
              <AuditTrail />
            ) : (
              <Navigate to="/inventory" replace />
            )
          }
        />
      </Route>
    </Routes>
  );
}
